/** @jsxImportSource @emotion/react */
import { css, useTheme } from '@emotion/react';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Box } from 'components/styled';

// TODO: move to theme?
import searchMuniLoop from 'assets/muni/file-searching-loop.gif';
import searchLiberecLoop from 'assets/liberec/file-searching-loop.gif';
import searchZlinLoop from 'assets/zlin/file-searching-loop.gif';
import searchPlzenLoop from 'assets/plzen/file-searching-loop.gif';
import searchMuni from 'assets/muni/file-searching-entrance.gif';
import searchLiberec from 'assets/liberec/file-searching-entrance.gif';
import searchZlin from 'assets/zlin/file-searching-entrance.gif';
import searchPlzen from 'assets/plzen/file-searching-entrance.gif';
import pageNotFoundMuniLoop from 'assets/muni/page-not-found-loop.gif';
import pageNotFoundLiberecLoop from 'assets/liberec/page-not-found-loop.gif';
import pageNotFoundZlinLoop from 'assets/zlin/page-not-found-loop.gif';
import pageNotFoundPlzenLoop from 'assets/plzen/page-not-found-loop.gif';
import pageNotFoundMuni from 'assets/muni/page-not-found-entrance.gif';
import pageNotFoundLiberec from 'assets/liberec/page-not-found-entrance.gif';
import pageNotFoundZlin from 'assets/zlin/page-not-found-entrance.gif';
import pageNotFoundPlzen from 'assets/plzen/page-not-found-entrance.gif';

const GifSwitch = (entranceGif: string, loopGif: string, time: number) => {
	const { t } = useTranslation('modules/not_found/');

	const [loop, setLoop] = useState(false);

	useEffect(() => {
		let mounted = true;
		setTimeout(() => {
			if (mounted) {
				setLoop(true);
			}
		}, time);

		return () => {
			mounted = false;
		};
	});

	return (
		<Box position="relative">
			<Box
				width="fit-content"
				css={css`
					visibility: ${loop ? 'hidden' : 'visible'};
				`}
			>
				<img src={entranceGif} alt={t('no_results')} width="100%" />
			</Box>
			<Box
				position="absolute"
				width="fit-content"
				top={0}
				css={css`
					visibility: ${loop ? 'visible' : 'hidden'};
				`}
			>
				<img src={loopGif} alt={t('no_results')} width="100%" />
			</Box>
		</Box>
	);
};

export const FileSearchingImage = () => {
	const { university } = useTheme();
	const time = 1215;
	switch (university) {
		case 'MUNI':
			return GifSwitch(searchMuni, searchMuniLoop, time);
		case 'LIBEREC':
			return GifSwitch(searchLiberec, searchLiberecLoop, time);
		case 'ZLIN':
			return GifSwitch(searchZlin, searchZlinLoop, time);
		case 'PLZEN':
			return GifSwitch(searchPlzen, searchPlzenLoop, time);
	}
};

const PageNotFoundImage = () => {
	const { university } = useTheme();
	const time = 1040;
	switch (university) {
		case 'MUNI':
			return GifSwitch(pageNotFoundMuni, pageNotFoundMuniLoop, time);
		case 'LIBEREC':
			return GifSwitch(pageNotFoundLiberec, pageNotFoundLiberecLoop, time);
		case 'ZLIN':
			return GifSwitch(pageNotFoundZlin, pageNotFoundZlinLoop, time);
		case 'PLZEN':
			return GifSwitch(pageNotFoundPlzen, pageNotFoundPlzenLoop, time);
	}
};
export default PageNotFoundImage;
